import { render, staticRenderFns } from "./chemicalEngineering.vue?vue&type=template&id=0a816c24&scoped=true"
import script from "./chemicalEngineering.vue?vue&type=script&lang=js"
export * from "./chemicalEngineering.vue?vue&type=script&lang=js"
import style0 from "./chemicalEngineering.vue?vue&type=style&index=0&id=0a816c24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a816c24",
  null
  
)

export default component.exports